'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/product');

(0, _themeSections.load)('*');

/* ---------------------------------------------
Sticky Nav on Scroll
------------------------------------------------ */
$(window).on('scroll', function (e) {
  e.preventDefault();
  stickyNav();
});

stickyNav();

function stickyNav() {

  if ($(window).scrollTop() > 100) {
    console.log(window.location.pathname);
    if (window.location.pathname == '/') {
      $('body').addClass('scrolled');
    }
  } else {
    if (window.location.pathname == '/') {
      $('body').removeClass('scrolled');
    }
  }
}

/* ---------------------------------------------
TICKER
------------------------------------------------ */
if ($('.ticker').length > 0) {
  $('.ticker').grouploop({
    // animation speed
    velocity: .5,

    // false = from left to right
    forward: false,

    // default selectors
    childNode: '.item',
    childWrapper: '.item-wrap',

    // enable pause on hover
    pauseOnHover: true,

    // stick the first item
    stickFirstItem: false,

    // callback
    complete: null
  });
}